import React, { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/ChatPage.css";
import send from "../assets/icons/send.png";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";

const ImageToDesciption = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [userImages, setUserImages] = useState({});
  const [inputImages, setInputImages] = useState([]);
  const [imageQueue, setImageQueue] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [showContinueModal, setShowContinueModal] = useState(false);
  const [isBotProcessing, setIsBotProcessing] = useState(false);
  const [botTimeoutId, setBotTimeoutId] = useState(null);

  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    if (imageQueue.length > 0 && currentImageIndex < imageQueue.length && !isBotProcessing) {
      setShowContinueModal(true);
    }
  }, [imageQueue, currentImageIndex, isBotProcessing]);

  const handleSend = () => {
    if (!input.trim() && inputImages.length === 0) return;

    const time = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    const userId = Date.now();

    const userMsg = { id: userId, sender: "user", message: input, time };
    setMessages((prev) => [...prev, userMsg]);
    setInput("");

    if (inputImages.length > 0) {
      setUserImages((prev) => ({ ...prev, [userId]: inputImages }));
      setImageQueue(inputImages);
      setCurrentImageIndex(0);
      setCurrentUserId(userId);
    }
    setInputImages([]);
  };

  const processImageAtIndex = (index) => {
    if (index >= imageQueue.length) return;

    setIsBotProcessing(true);
    const botMsgId = Date.now();
    const botMsg = {
      id: botMsgId,
      sender: "bot",
      message: "",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };

    setMessages((prev) => [...prev, botMsg]);

    const fullText = `Description for image ${index + 1}`;
    let currentCharIndex = 0;

    const typing = () => {
      if (currentCharIndex >= fullText.length) {
        setIsBotProcessing(false);
        return;
      }

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === botMsgId ? { ...msg, message: fullText.slice(0, currentCharIndex + 1) } : msg
        )
      );

      currentCharIndex++;
      const timeout = setTimeout(typing, 50);
      setBotTimeoutId(timeout);
    };

    typing();
  };

  const stopBotResponse = () => {
    if (botTimeoutId) {
      clearTimeout(botTimeoutId);
      setBotTimeoutId(null);
      setIsBotProcessing(false);
    }
  };

  const handleContinue = () => {
    setShowContinueModal(false);
    processImageAtIndex(currentImageIndex);
    setCurrentImageIndex((prev) => prev + 1);
  };

  const handleAddImage = (msgId) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.onchange = () => {
      const files = Array.from(input.files);
      const urls = files.map((file) => URL.createObjectURL(file));
      setUserImages((prev) => ({
        ...prev,
        [msgId]: [...(prev[msgId] || []), ...urls],
      }));
    };
    input.click();
  };

  const handleAttachClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.onchange = () => {
      const files = Array.from(input.files);
      const urls = files.map((file) => URL.createObjectURL(file));
      setInputImages((prev) => [...prev, ...urls]);
    };
    input.click();
  };

  const renderMessage = (msg) => {
    const isBot = msg.sender === "bot";
    const profile = isBot
      ? "https://img.freepik.com/free-vector/chatbot-chat-message-vectorart_78370-4104.jpg"
      : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

    const bubbleClass = isBot ? "bot-bubble" : "user-bubble";
    const containerAlign = isBot ? "flex-row" : "flex-row-reverse";
    const iconAlign = isBot ? "justify-content-start" : "justify-content-end";
    const iconMargin = isBot ? "ms-3" : "me-3";
    const images = userImages[msg.id] || [];

    return (
      <div className={`d-flex ${containerAlign} align-items-start my-3`} key={msg.id}>
        <div className="d-flex flex-column" style={{ maxWidth: "75%" }}>
          <div className={`chat-bubble ${bubbleClass}`}>
            <div className="d-flex align-items-center gap-2 mb-2">
              <img src={profile} className="chat-avatar" alt="avatar" />
              <strong>{isBot ? "Bot" : "User"}</strong>
              <small className="text-muted">{msg.time}</small>
            </div>
            <div>{msg.message}</div>

            {!isBot && images.length > 0 && (
              <div className="mt-3">
                <div className="main-image-container mb-2">
                  <img src={images[0]} alt="main" className="main-image" />
                </div>
                {images.length > 1 && (
                  <div className="thumbnail-container">
                    {images.slice(1).map((url, idx) => (
                      <div key={idx} className="thumbnail-wrapper">
                        <img src={url} alt={`thumb-${idx}`} className="thumbnail-image" />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className={`d-flex text-secondary gap-3 mt-1 ${iconAlign} ${iconMargin}`}>
            {isBot ? (
              <>
                <i className="bi bi-volume-up" title="Play Sound" />
                <i className="bi bi-clipboard" title="Copy" />
                <i className="bi bi-arrow-clockwise" title="Refresh" />
              </>
            ) : (
              <>
                <i className="bi bi-pencil" title="Edit" />
                <i className="bi bi-clipboard" title="Copy" />
                <i
                  className="bi bi-plus-square"
                  title="Add Image"
                  onClick={() => handleAddImage(msg.id)}
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid mt-3 position-relative">
      <div className="chat-box">
        {messages.map((msg) => renderMessage(msg))}
        <div ref={chatEndRef} />
      </div>

    
    
      {inputImages.length > 0 && (
        <div className="d-flex flex-wrap mb-2">
          {inputImages.map((url, idx) => (
            <div key={idx} className="image-preview-container">
              <img src={url} alt={`preview-${idx}`} className="image-preview" />
              <button
                className="image-remove-btn"
                onClick={() => setInputImages((prev) => prev.filter((_, i) => i !== idx))}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {isBotProcessing && (
        <div className="floating-bot-status text-center">
          <div className="d-flex justify-content-center align-items-center gap-2">
            <div className="recording-dot" onClick={stopBotResponse} title="Stop Response" />
            <span>Stop Generating</span>
          </div>
        </div>
      )}

      <div className="border rounded p-3 mt-2" style={{ minHeight: "120px" }}>
        <div className="mb-1">
          <input
            type="text"
            className="form-control border-0 shadow-none"
            placeholder="How can I help you?"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
        </div>
        <hr />
        <div className="d-flex align-items-center justify-content-between p-2 rounded-3">
          <div className="d-flex gap-3">
            <button className="btn btn-link text-muted p-0" onClick={handleAttachClick}>
              <i className="bi bi-paperclip fs-5"></i>
            </button>
            <button className="btn btn-link text-muted p-0">
              <i className="bi bi-volume-up fs-5"></i>
            </button>
            <button className="btn btn-link text-muted p-0">
              <i className="bi bi-mic fs-5"></i>
            </button>
            <button className="btn btn-link text-muted p-0">
              <GraphicEqIcon fontSize="medium" style={{ color: "#6c757d" }} />
            </button>
          </div>
          <button className="custom-send-btn" onClick={handleSend}>
            <img src={send} alt="send" />
          </button>
        </div>
      </div>

      <div className="text-center mt-3">
        <p>
          By Messaging, you agree to our <strong>Terms</strong> and have read our{" "}
          <strong>Privacy Policy</strong>.
        </p>
      </div>

      {showContinueModal && (
        <div className="continue-modal">
          <div className="continue-card">
            <div className="continue-header">Image 1 Description Complete</div>
            <div className="continue-body">
              <p className="continue-message">
                The description for the first image is ready. Would you like to proceed to the second image?
              </p>
              <div className="continue-buttons">
                <button className="btn-secondary-outline" onClick={() => setShowContinueModal(false)}>
                  No, Maybe Later
                </button>
                <button className="btn-primary" onClick={handleContinue}>
                  Yes, Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageToDesciption;
